/*
 * utils.axios.ts
 *
 * export interface AxiosResponse< T = any, D = any> {
 *  data: T;
 *  status: number;
 *  statusText: string;
 *  headers: RawAxiosResponseHeaders | AxiosResponseHeaders;
 *  config: InternalAxiosRequestConfig<D>;
 *  request?: any;
 * }
 *
 * interface Error {
 *  name: string;
 *  message: string;
 *  stack?: string;
 * }
 *
 * export class AxiosError<T = unknown, D = any> extends Error {
 *  constructor(
 *    message?: string,
 *    code?: string,
 *    config?: InternalAxiosRequestConfig<D>,
 *    request?: any,
 *    response?: AxiosResponse<T, D>
 *  );
 *  :
 *  :
 *  .
 * }
 *
 * HTTP AxiosResponse object:
 * {
 *    config: {},  //
 *    headers: {}, //
 *    request: {}, //
 *    status: 200, // 3 digits numeric status code
 *    statusText: "OK", // Short description of status code
 *    //
 *    data: // this is where custom response data being return
 *    {
 *      kX1 : xxx,
 *      kX2 : xxx,
 *    }
 * }
 *
 */
//
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type { mtAxiosReturn } from 'src/config/config.type.axios';
// import { moAxiosReturn } from 'src/config/config.type.axios';
//
export class mcUtilsAxios {
  public cpifGetAlreadyInit(): mtAxiosReturn {
    const loAxiosReturn: mtAxiosReturn = {
      cpibIsError: false,
      cpisError: '',
      cpisMessage: 'Already Init!',
      cpinStatusCode: 0,
      cpixData: null,
    };
    //
    return loAxiosReturn;
  }
  //
  public cpifGetReturnOK(poResponse: AxiosResponse, pbAttachData: boolean = false): mtAxiosReturn {
    const loAxiosReturn: mtAxiosReturn = {
      cpibIsError: false,
      cpisError: '',
      cpisMessage: '[' + poResponse.status.toString() + ' - ' + poResponse.statusText + ']',
      cpinStatusCode: poResponse.status,
      cpixData: null,
    };
    if (true === pbAttachData) {
      loAxiosReturn.cpixData = poResponse.data;
    }
    //
    return loAxiosReturn;
  }
  //
  public cpifGetReturnError(poError: unknown): mtAxiosReturn {
    let loAxiosReturn: mtAxiosReturn;
    //
    if (axios.isAxiosError(poError)) {
      loAxiosReturn = {
        cpibIsError: true,
        cpisError: poError.response?.data.error,
        cpisMessage:
          '[' +
          poError.response?.data.statusCode +
          ' - ' +
          poError.response?.data.error +
          '] ' +
          poError.response?.data.message,
        cpinStatusCode: poError.response?.data.statusCode,
        cpixData: null,
      };
    } else {
      //
      // TODO: Need to find out the NATIVE error structure!!!
      //
      loAxiosReturn = {
        cpibIsError: true,
        cpisError: (<Error>poError).name, //'Internal Server Error!',
        cpisMessage: '[0 -' + (<Error>poError).name + '] ' + (<Error>poError).message,
        cpinStatusCode: 0,
        cpixData: null,
      };
    }
    //
    return loAxiosReturn;
  }
}
//#end#
